"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityViewNavigation = exports.EntityViewNavigationDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var current_path_name_1 = require("../../utils/current-path-name");
var current_user_can_1 = require("../../utils/current-user-can");
var entity_update_button_1 = require("./entity-update-button");
var entity_connections_button_1 = require("./entity-connections-button");
var entity_conversation_button_1 = require("./entity-conversation-button");
var entity_details_button_1 = require("./entity-details-button");
exports.EntityViewNavigationDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    font-size: ", ";\n  "], ["\n    display: flex;\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(14))
});
var UpdateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    text-transform: none;\n    background-position: top right;\n    font-weight: 500;\n    font-size: ", ";\n    display: none;\n    padding-right: ", ";\n    margin-right: ", ";\n    ", ";\n    \n    ", "\n  "], ["\n    text-transform: none;\n    background-position: top right;\n    font-weight: 500;\n    font-size: ", ";\n    display: none;\n    padding-right: ", ";\n    margin-right: ", ";\n    ", ";\n    \n    ", "\n  "])), theme_1.theme.FONT_SIZE(14), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.DOT_BG('v', 'line-mid', 2, 4), function (props) {
    return props.isActive && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    "], ["\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var DetailsButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), ButtonStyles)
});
var ConnectionsButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), ButtonStyles)
});
var ConversationButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ButtonStyles)
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  DetailsButton: (0, styled_components_1.default)(entity_details_button_1.EntityDetailsButton)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), DetailsButtonStyles),
  UpdateButton: (0, styled_components_1.default)(entity_update_button_1.EntityUpdateButton)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), UpdateButtonStyles),
  ConnectionsButton: (0, styled_components_1.default)(entity_connections_button_1.EntityConnectionsButton)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ConnectionsButtonStyles),
  ConversationButton: (0, styled_components_1.default)(entity_conversation_button_1.EntityConversationButton)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ConversationButtonStyles)
};
var EntityViewNavigation = function (props) {
  var className = props.className,
    entity = props.entity,
    child = props.child;
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var from = (0, current_path_name_1.currentPathName)();
  if (!definition) {
    throw new Error("Error: Entity Details controls cannot be rendered. Cannot determine type name");
  }
  var routes = definition.routes;
  var canWrite = (0, current_user_can_1.currentUserCanUpdate)(definition.name) || entity && entity.isWriteable;
  var hasUpdateButton = routes.update && canWrite;
  return react_1.default.createElement(My.Container, {
    className: className
  }, hasUpdateButton && react_1.default.createElement(My.UpdateButton, {
    priority: 'icon',
    label: definition.update.label,
    from: from,
    iconSize: 18,
    entity: entity
  }));
};
exports.EntityViewNavigation = EntityViewNavigation;
exports.EntityViewNavigation.defaultProps = exports.EntityViewNavigationDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;